<script lang="ts">
    import { isMobile, location, login, openModal, rerender, sidebarOverlay, users } from "./lib/store"
    import Header from "./lib/components/Header.svelte"

    import NotFound from "./routes/NotFound.svelte"
    import Notification from "./lib/components/Notification.svelte"
    import Login from "./routes/Login.svelte"
    import Dashboard from "./routes/Dashboard.svelte"
    import { getCachedEntries } from "./api"
    import Task from "./routes/Task.svelte"
    import TaskManualProtocol from "./routes/TaskManualProtocol.svelte"
    import Order from "./routes/Order.svelte"
    import DateModal from "./lib/components/formComponents/DateModal.svelte"
    import { onMount } from "svelte"
    import SidebarOverlay from "./lib/components/SidebarOverlay.svelte"
    import ActionApproval from "./lib/components/ActionApproval.svelte"
    import SetLocation from "./lib/taskSteps/widgets/location/SetLocation.svelte"

    export let url = ""

    if (url) {
        // ssr
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? l[1] : "",
            hash: "",
            push: false,
            pop: false,
        }
    }
    getCachedEntries("user").then((res) => {
        const usersObj = {}
        res.forEach((user) => {
            usersObj[user.id] = user
        })
        $users = usersObj
    })
    onMount(() => {
        const updateModalState = () => {
            $openModal = document.getElementsByClassName("dialog-open").length > 0
        }
        const interval = setInterval(updateModalState, 100)
        return () => clearInterval(interval)
    })
    let innerWidth = 0
    $: $isMobile = innerWidth < 1700
    $: pathSegments = $location?.path ? $location.path.split("/").filter(Boolean) : []
    $: isManualProtocolRoute = pathSegments.length >= 5 && pathSegments[pathSegments.length - 1] === "manual-protocol"
</script>

<svelte:window bind:innerWidth="{innerWidth}" />
<Header />

<main>
    {#key $rerender}
        {#if $location?.path?.startsWith("/login")}
            <Login />
        {:else if $location?.path == "/" && $login?.user}
            <Dashboard />
        {:else if $location?.path.includes("/order") && $login?.user}
            {#if pathSegments.length === 2}
                <Order orderId="{pathSegments[1]}" />
            {:else if isManualProtocolRoute}
                <TaskManualProtocol
                    orderId="{pathSegments[1]}"
                    taskId="{pathSegments[pathSegments.length - 2]}"
                />
            {:else}
                <Task
                    taskId="{pathSegments[pathSegments.length - 1]}"
                    orderId="{pathSegments[1]}"
                />
            {/if}
        {:else if $login?.user}
            <NotFound />
        {/if}
    {/key}
    <Notification />
</main>
<DateModal />
{#if $sidebarOverlay}
    <SidebarOverlay />
{/if}
<ActionApproval />
<SetLocation />

<style
    lang="less"
    global
>
    @import "../assets/fonts/fonts.css";
    @import "../assets/variables.less";
    @import "../assets/main.less";
    @import "../assets/formular.less";
    @import "../assets/Table.less";
    @import "flatpickr/dist/flatpickr.min.css";
    @import "flatpickr/dist/themes/material_red.css";
    html {
        font-size: 20px;
        @media @mobile {
            font-size: 16px;
        }
        -ms-overflow-style: none; /* Internet Explorer 10+ */
        scrollbar-width: none; /* Firefox */

        &::-webkit-scrollbar {
            display: none; /* Safari and Chrome */
        }
    }
    body {
        &.no-scroll,
        &.no-overflow {
            overflow: hidden;
        }
        -ms-overflow-style: none; /* Internet Explorer 10+ */
        scrollbar-width: none; /* Firefox */

        &::-webkit-scrollbar {
            display: none; /* Safari and Chrome */
        }
        height: 100%;
        width: 100%;
        min-height: 100vh;
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: column;
        main {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
    }
</style>
